import { useContext,useEffect, useState } from 'react'

import { fetchEnrolledCadences,fetchEnrolledSequences } from 'api'
import { EnabledIntegrationsContext } from 'context/enabledIntegrations'

interface Sequence {
  id: number
  attributes?: {
    createdAt: string
    enabled: boolean
    name: string
  }
}

const outreachCache: Map<string, Promise<Sequence[]>> = new Map()
const salesloftCache: Map<string, Promise<Sequence[]>> = new Map()

export const useEnrolledSequencesData = (email?: string): Sequence[] | undefined => {
  const [sequences, setSequences] = useState<Sequence[] | undefined>(undefined)
  const enabledIntegrations = useContext(EnabledIntegrationsContext)

  useEffect(() => {
    if (!email || !enabledIntegrations.outreach) {
      return
    }

    let outreachPromise = outreachCache.get(email)
    let timeout: ReturnType<typeof setTimeout>

    if (!outreachPromise) {
      outreachPromise = fetchEnrolledSequences(email)
      outreachCache.set(email, outreachPromise)

      // invalidate cache once a minute
      timeout = setTimeout(() => {
        outreachCache.delete(email)
        setSequences(undefined)
      }, 60_000)
    }

    outreachPromise.then(({ enrolledSequences }: any) => {
      setSequences(enrolledSequences)
    })

    return () => clearTimeout(timeout)
  }, [email, enabledIntegrations.outreach])

  return sequences
}

export const useEnrolledCadencesData = (email?: string): Sequence[] | undefined => {
  const [cadences, setCadences] = useState<Sequence[] | undefined>(undefined)
  const enabledIntegrations = useContext(EnabledIntegrationsContext)

  useEffect(() => {
    if (!email || !enabledIntegrations.salesloft) {
      return
    }

    let salesloftPromise = salesloftCache.get(email)
    let timeout: ReturnType<typeof setTimeout>

    if (!salesloftPromise) {
      salesloftPromise = fetchEnrolledCadences(email)
      salesloftCache.set(email, salesloftPromise)

      // invalidate cache once a minute
      timeout = setTimeout(() => {
        salesloftCache.delete(email)
        setCadences(undefined)
      }, 60_000)
    }

    salesloftPromise.then((enrolledCadences: any) => {
      setCadences(enrolledCadences)
    })

    return () => clearTimeout(timeout)
  }, [email, enabledIntegrations.salesloft])

  return cadences
}
